import TituloNegrito from './TituloNegrito';
import CardOutraCertificacao from './CardOutraCertificacao';

import { retornarTexto } from '../helpers/textoHelper'

function OutrasCertificacoes({ item, resolucaoMobile, idioma }) {
    const certificacoes = [1, 2, 3, 4, 5].filter((numero) => item[`Nome da certificação adicional ${numero}`])

    if (certificacoes.length === 0) return <></>

    return (
        <div className='animate__animated animate__fadeIn d-flex flex-column align-items-center justify-content-center' style={{ gap: '20px' }}>
            <TituloNegrito texto={retornarTexto(idioma, 'outrasCertificacoes')} />
            <div className='mb-5 animate__animated animate__fadeIn d-flex flex-wrap align-items-center justify-content-center' style={{ gap: '30px' }}>
                {certificacoes.map((numero) => <CardOutraCertificacao key={numero} link={item[`Link do site da certificação adicional ${numero}`]} nome={item[`Nome da certificação adicional ${numero}`]} urlImagem={item[`Link da imagem da certificação adicional ${numero}`]} resolucaoMobile={resolucaoMobile}/>)}
            </div>
        </div>
    );
}
export default OutrasCertificacoes;
